module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-23.e7e43425.jpg";